import { PortfolioService } from "@/services/network/portfolio";
import { useQuery } from "@tanstack/react-query";

const portfolioService = new PortfolioService();

const usePortfolioCategory = () => {
  const { data, isLoading, isError, } = useQuery({
    queryKey: PortfolioService.QUERY_KEY.FETCH_ALL,
    queryFn: () => portfolioService.getCategoryList(),
  });

  return {
    data,
    isLoading,
    isError,
  };
};

export default usePortfolioCategory;